import { readingTime, formatDate, calendarFormatMonths } from '@/shared/utils/time';

export const minutesStr = (time: number): string => {
  return readingTime(time);
};

export const getDate = (date?: Date) => {
  if (!date) {
    return '';
  }

  const currentTime: Date = new Date();
  const year: number = currentTime.getFullYear();
  const getYear: number = Number(formatDate(date, 'yyyy'));

  const format: string = year === getYear ? 'd MMMM' : 'd MMMM yyyy';

  return calendarFormatMonths(date, format);
};
